import { useLocation } from "react-router-dom";
import { detectLang } from "@/content/site";

export function useLang() {
  const { pathname } = useLocation();
  return detectLang(pathname);
}

export function useCurrentPath() {
  const { pathname } = useLocation();
  // Normalize trailing slashes
  if (pathname !== "/" && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname;
}
